import React, {useEffect, useState} from 'react'
import Mapa from './Mapa'
import Tabla from './Tabla'
import axios from 'axios';
import qs from 'qs';
import { authUser } from '../funciones/AuthUser'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import {Box, Button, LinearProgress,FormControl, InputLabel, Select, MenuItem,
     RadioGroup, Radio,
     FormControlLabel,
     Typography, 
 } from "@material-ui/core";
import moment from 'moment';
import {llamaApiCargaToken,llamadaApiToken,ErrorGeneral } from '../funciones/ClienteAxios';
import { ordenMapBx } from '../MapaEdo/OrdenxMapBox';
import SearchIcon from '@material-ui/icons/Search';
import Relojes from './Relojes';
import ModalNvoEdit from './ModalNvaRuta';
import ModalNvoEditGPS from './MapaPoligonos';
const MapaRuta =()=>{
    const history = useHistory();
    const source = axios.CancelToken.source();
    const auxId =localStorage.getItem('UsuId') ; 
    const nvl= localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0; 
    const Dispvo =localStorage.getItem('Dispvo') ;       
    const auxDispV =Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs' 
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext);    
    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({
        inicio: new Date(),
        final: new Date(),
    });
    const[modalGPS, setModalGPS]= useState(false)
    const[lista, setLista]= useState([])
    const [espera,setEspera]= useState(false);
    const[bandera, setBandera]= useState(true)
    const [contador, setContador] = useState(1);
    const[periodo,setPeriodo]= useState("1A");  
    const[listDistrito,setListDistrito]= useState([]);  
    const[listPoliDto, setListPoliDto]= useState([]);  
    const[listPoliOtb, setListPoliOtb]= useState([]); 
    const[listColOtb, setListColOtb]= useState([]); 
    const[listColPolig, setListColPolig]= useState([]); 
    const[listMarcador, setListMarcador]= useState([]);   
    const[listNumOtb, setListNumOtb]= useState([]);   
    const[listEleccion, setListEleccion]= useState([]);   
    const[listTipo, setListTipo]= useState([]);   
    const[listRutas, setListRutas]= useState([]);   
    const[listRutaGps, setListRutaGps]= useState([]);   
    const[distrito, setDistrito]= useState([]);  
    const[modalNvo, setModalNvo]= useState(false);  
    const[modalEdit, setModalEdit]= useState(false);  
    const[rutaRegistro, setRutaRegistro]= useState([]);  
    const[filtro, setFiltro]= useState({tipo:"", ruta:""});  
    const{tipo, ruta} = filtro
    

    useEffect(()=>{             
        const autenticado = authUser();
        if(!autenticado){
            localStorage.clear();
            history.push("/");
            guardarUsuario([])
        }
        else
        {   const usu= localStorage.getItem('UsuarioNom');                 
            if (usuario.length===0) 
            {
                guardarUsuario({Nombre:usu,nivel:nvl});                                                               
            }                      
            
            getListDto()
            getListTipo()
            //getListRutaGps(1)
            guardarGenerales({...generales,Titulo:'Rutas'})      
                
        }
        
        return ()=> {
            source.cancel();
        }      
        //la siguiente linea puede generar errores o no en el useEffect
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(()=>{
        if (distrito.length!==0 && tipo.length!==0) {
            setListRutaGps([])
            setRutaRegistro([])   
            setFiltro({...filtro,"ruta":""})     
            getListRutas(distrito)
        }
    },[fechasSeleccionadas])

    function getListTipo()  {            
        const auxU= `lugar/ruta/tipo`;                            
        const dataInfo = qs.stringify({                
            Usuario:auxId, ip:"127.0.0.0",                      
            idDispositivo:auxDispV,
            });
                    
        function respuesta (auxiliar) 
        {   if (auxiliar[0].Id !== -1) 
            {                           
                setListTipo(auxiliar) 
            }                                                            
        }
        llamadaApiToken(dataInfo, auxU, respuesta, ErrorGeneral,  history, source);
    };

    function getListRutaGps(auxRuta)  {            
        const url= `lugar/ruta/gps`;                            
        const data = qs.stringify({                
            Usuario:auxId, ip:"127.0.0.0",      
            Ruta:auxRuta,                
            idDispositivo:auxDispV,
            });
                    
        function respuesta (auxiliar) 
        {   if (auxiliar[0].Id !== -1) 
            {   let auxArr=[]                       
                auxiliar.forEach((poligono)=>{                                        
                  auxArr.push([poligono.Ln, poligono.Lt])                  
                })
                setListRutaGps(auxArr) 
            }                                                            
        }
        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
    };
    
    function getListDto()  {            
        const auxU= `lugar/municipio/distrito`;                            
        const dataInfo = qs.stringify({                
            Usuario:auxId,     
            Estado: 2,  ip:"127.0.0.0",                      
            idDispositivo:auxDispV,
            });
                    
        function respuesta (auxiliar) 
        {   if (auxiliar[0].Id !== -1) 
            {   let listNvo=[]
                auxiliar.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom} - ${element.ComNom}`})
                });                                                 
                setListDistrito(listNvo) 
            }                                                            
        }
        llamadaApiToken(dataInfo, auxU, respuesta, ErrorGeneral,  history, source);
    };
    
    const getListPoliDto = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito/gps";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr=[]
              //  console.log([auxiliar[0].Ln.toFixed(5), auxiliar[0].Lat.toFixed(5)]);
                auxiliar.forEach((poligono)=>{                                        
                  auxArr.push([poligono.Ln, poligono.Lt])
                  //auxArr.push({coordinates:[poligono.Ln, poligono.Lt]})
                })
                //console.log(auxArr);
                
                setListPoliDto(auxArr)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListPoliOtb = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito/otb/gps";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr2=[], auxArr3=[], auxListOtb=[], auxCol=[]                            
                //auxArr[0]=[]                auxArr[1]=[]
              /*   auxiliar[0].otb[0].gps.forEach((poligono)=>{                                        
                  auxArr.push([poligono.Ln, poligono.Lt])                  
                })   */              
                
                /* auxiliar[0].otb.forEach(element => {
                    let nvoArr=[]
                    element.gps.forEach((poligono)=>{
                        nvoArr.push([poligono.Ln, poligono.Lt])
                    })
                    auxArr.push([nvoArr])
                    
                    auxArr2.push({ 'type': 'Feature',
                    'geometry': {
                        "properties":{IdOTB:element.Id, colOtb:element.Nom},
                        'type': 'Polygon',                         
                        'coordinates': auxArr
                    }})
                    auxCol.push(element.Col)
                }); */
                
                    /* let auxCol=[]
                    let nvoArr=[]
                    auxiliar[0].otb[0].gps.forEach((poligono)=>{
                        nvoArr.push([poligono.Ln, poligono.Lt])
                    })
                    //auxArr.push([nvoArr])
                    
                    auxArr2.push({ 
                        "id":auxiliar[0].otb[0].Id,
                        'type': 'Feature',
                        "properties":{
                            "IdOTB":auxiliar[0].otb[0].Id, 
                            "colOtb":auxiliar[0].otb[0].Col,
                            "nomOtb":auxiliar[0].otb[0].Nom,
                    },
                        'geometry': {                            
                            'type': 'MultiPolygon',                         
                            'coordinates': [[nvoArr]]
                        }
                    })
                    auxCol.push(auxiliar[0].otb[0].Col)                                    
                    nvoArr=[]

                    auxiliar[0].otb[1].gps.forEach((poligono)=>{
                        nvoArr.push([poligono.Ln, poligono.Lt])
                    })                  
                    auxArr2.push({ 
                        "id":auxiliar[0].otb[1].Id,
                        'type': 'Feature',
                        "properties":{
                            "IdOTB":auxiliar[0].otb[1].Id, 
                            "colOtb":auxiliar[0].otb[1].Col},
                            "nomOtb":auxiliar[0].otb[1].Nom,
                            
                        'geometry': {                        
                            'type': 'MultiPolygon',                         
                            'coordinates': [[nvoArr]]
                        }
                    })
                    auxCol.push(auxiliar[0].otb[1].Col)    */             
                    
                auxCol=["match",["get", "IdOTB"]]
                auxiliar[0].otb.forEach((element)=>{
                    let nvoArr=[]
                    if (element.gps) {
                        element.gps.forEach((poligono)=>{
                            nvoArr.push([poligono.Ln, poligono.Lt])
                        })     
                        
                        auxArr2.push({ 
                            "id":element.Id,
                            'type': 'Feature',
                            "properties":{
                                "IdOTB":element.Id, 
                                "colOtb":element.Col
                            },
                            "nomOtb":element.Nom,                                
                            'geometry': {                        
                                'type': 'MultiPolygon',                         
                                'coordinates': [[nvoArr]]
                            }
                        })
                        auxCol.push(element.Id)      
                        auxCol.push(element.Col)  
                        auxListOtb.push({...element, coordinates:[element.Ln, element.Lt]})         
                    }
                    
                })                    
                auxCol.push('#cedded')                   
                    
                auxArr3={"type": "FeatureCollection",
                    "name": "Cochabamba",
                    "features":auxArr2}
             
                setListNumOtb(auxListOtb)
                setListColPolig(auxCol)                                                   
                setListPoliOtb(auxArr3)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListMarcador = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/recinto/dto";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr=[]              
                auxiliar.forEach((poligono)=>{                                        
                  auxArr.push({coordinates:[poligono.ln, poligono.lt], original:poligono})                  
                })                
                setListMarcador(auxArr)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListEleccion = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  Periodo:periodo,
            Usuario: auxId, Dto:Distrito,   idDispositivo: auxDispV,
        });
        const url = "eleccciones/bolivia/resultado/dto/otb";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let  auxCol=[], listCol=[]         
                auxCol=["match",["get", "IdOTB"]]     
                auxiliar.forEach((poligono)=>{                                        
                    ordenMapBx(listCol, poligono.Otb, poligono.Col)             
                })
                listCol.forEach((elemento)=>{
                    auxCol.push(elemento.pos)
                    auxCol.push(elemento.auxColor)
                    //cuenta=cuenta+elemento.pos.length
                })  
                auxCol.push('#cedded')
                setListEleccion(auxiliar)                 
                setListColOtb(auxCol)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListRutas = (Distrito) => {
        const fInicio = moment(fechasSeleccionadas.inicio).format("YYYY-MM-DD")
        const fFinal = moment(fechasSeleccionadas.final).format("YYYY-MM-DD")
        const data = qs.stringify({ ip:"127.0.0.0",  Tipo:tipo, Status:-1,
            FIni:`${fInicio}T00:00:00`, FFin:`${fFinal}T23:59:59`,
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/ruta/v2/filtro";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {               
                setListRutas(auxiliar)
            }
            else{
                setListRutas([])
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const onChangeDto=(e)=>{    
        if (e!== null && e!== undefined) 
        { //setMuniSelect(e)               
            setDistrito(e.target.value)    
            setListPoliDto([])
            setListPoliOtb([])
            setListMarcador([])
            getListPoliDto(e.target.value)  
            getListPoliOtb(e.target.value)  
            getListMarcador(e.target.value)  
            //getListEleccion(e.target.value)
            setListRutaGps([])
            setFiltro({...filtro,"ruta":""})  
            setRutaRegistro([])   
            getListRutas(e.target.value)
            
        }else
        {   setDistrito("")           
        }               
    } 

    const generarLista=( )=>{    
        if (distrito.length!==0   ) 
        {  
            setListPoliDto([])
            setListPoliOtb([])
            setListMarcador([])
            getListPoliDto(distrito)  
            getListPoliOtb(distrito)  
            getListMarcador(distrito)  
            if ( ruta.length!==0) {
                getListRutaGps(ruta)    
            }                        
        }             
    } 
    
    const onChangeTipo=(e)=>{    
        if (e!== null && e!== undefined) 
        { //setMuniSelect(e)               
            setFiltro({...filtro,[e.target.name]:e.target.value})                
            
            //getListRutas(e.target.value)
            
        }else
        {   setDistrito("")           
        }               
    } 

    const onChangeRuta=(e)=>{    
        if (e!== null && e!== undefined) 
        { //setMuniSelect(e)               
            setFiltro({...filtro,[e.target.name]:e.target.value})                
            const filtroRuta = listRutas.filter((elemento)=> elemento.Id === e.target.value)
            const filtroDto = listDistrito.filter((elemento)=> elemento.Id === filtroRuta[0].DtId)
            setRutaRegistro({Id:e.target.value, Nom:filtroRuta[0].Descr, original:filtroRuta[0],
                centro: [filtroDto[0].Lon, filtroDto[0].Lat], ObjId: filtroRuta[0].ObjId })   
            getListRutaGps(e.target.value)
            
        }else
        {   setDistrito("")           
        }               
    } 

    const abrirModEdit=()=>{
        const filtroRuta = listRutas.filter((elemento)=> elemento.Id === rutaRegistro.Id)
        const filtroDto = listDistrito.filter((elemento)=> elemento.Id === filtroRuta[0].DtId)
        setRutaRegistro({...rutaRegistro, Nom:filtroRuta[0].Descr, original:filtroRuta[0],
            centro: [filtroDto[0].Lon, filtroDto[0].Lat], ObjId: filtroRuta[0].ObjId })   
        setModalEdit(true)
    }


    const modNvo = modalNvo ? <ModalNvoEdit modalAbierto={modalNvo} setModalAbierto={setModalNvo} titulo="Nueva Ruta" 
                                    listTipo={listTipo} auxReg={[]}  getDatos={()=>{}} listRutas={[]} setListRutas={[]}/> : null

    const modEdit = modalEdit ? <ModalNvoEdit modalAbierto={modalEdit} setModalAbierto={setModalEdit} titulo={`Editar Ruta ${rutaRegistro.Nom}`} 
                                    listTipo={listTipo} auxReg={rutaRegistro}  getDatos={()=>{}} 
                                    listRutas={listRutas} setListRutas={setListRutas} /> : null

    const modGPS = modalGPS ? <ModalNvoEditGPS modalAbierto={modalGPS} setModalAbierto={setModalGPS} titulo={`Editar GPS de ${rutaRegistro.Nom}`} 
                                   auxReg={[]}  getDatos={getListRutaGps} ruta={rutaRegistro} listRutaGps={listRutaGps} /> : null 
    return(
    <Box display={"flex"} flexDirection={"column"}>
        {modNvo}
        {modGPS}
        {modEdit}
        <Box display={"flex"} flexDirection={"row"}>
            <Box mt={1} ml={1}>
                <Button variant='contained' style={{width:"7.8rem", backgroundColor:process.env.REACT_APP_Btn_Color}}
                   color="primary"   onClick={()=>setModalNvo(true)}>Nueva Ruta</Button>
            </Box>
           
           <Box mr={1} ml={1} >       
                <Button onClick={generarLista} style={{width:"7rem", marginTop:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
                    variant="contained"  color="primary"  startIcon={<SearchIcon/>} 
                    disabled={espera}
                >   
                    Buscar     
                </Button>                                                                                                                        
            </Box>   
            <Box>
                <Relojes
                    fechasSeleccionadas={fechasSeleccionadas}
                    setFechasSeleccionadas={setFechasSeleccionadas}
                />
            </Box>
          
            { listTipo.length!==0 ?                
                <Box display={"flex"} mb={2} mt={1} ml={1}>
                <FormControl size='small'  style={{ minWidth:8+'rem'}} >
                    <InputLabel size='small' variant="outlined" id="tipo-label-nvo">Tipo</InputLabel>
                    <Select  size='small' variant="outlined"    
                        label="Tipo" id="tipo-select2" name="tipo"
                        value={tipo} onChange={onChangeTipo}
                    >
                        {listTipo.map((secc, index) => {
                            if(secc.Id>0) {
                            return(
                            <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                <em>{secc.Nom }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                </FormControl>
                </Box>
            :   null
            }
            { listDistrito.length!==0 ?                
                <Box display={"flex"} mb={2} mt={1} ml={1}>
                <FormControl size='small'  style={{ minWidth:10+'rem'}} >
                    <InputLabel size='small' variant="outlined" id="distrito-label-nvo">Distrito</InputLabel>
                    <Select  size='small' variant="outlined"    
                        label="Distrito" id="Distrito-select2" name="distrito"
                        value={distrito} onChange={onChangeDto}
                    >
                        {listDistrito.map((secc, index) => {
                            if(secc.Id>0) {
                            return(
                            <MenuItem size='small' value={`${secc.Id}`} key={`${secc.Id}`}>
                                <em>{secc.cadena }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                </FormControl>
                </Box>
            :   null
            }
          
            { listRutas.length!==0 ?                
                <Box display={"flex"} mb={2} mt={1} ml={1}>
                <FormControl size='small'  style={{ minWidth:14+'rem'}} >
                    <InputLabel size='small' variant="outlined" id="ruta-label-nvo">Rutas</InputLabel>
                    <Select  size='small' variant="outlined"    
                        label="Rutas" id="ruta-select2" name="ruta"
                        value={ruta} onChange={onChangeRuta}
                    >
                        {listRutas.map((secc, index) => {
                            if(secc.Id>0) {
                            return(
                            <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                <em>{secc.Descr }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                </FormControl>
                </Box>
            :   distrito.length !==0 && tipo.length!==0 ?<Typography style={{marginLeft:"1rem", marginTop:"1rem"}}  component="h1" variant="h5" >Sin Rutas</Typography> :null
            }
            { rutaRegistro.length!==0?
                <Box mt={1} ml={1}>
                    <Button variant='contained' style={{width:"8rem", backgroundColor:process.env.REACT_APP_Btn_Color}}
                        color="primary"   onClick={abrirModEdit}>Editar Ruta</Button>
                </Box>
                :null
            }
            {rutaRegistro.length !==0 ? 
                <Box mt={1} ml={1}>
                    <Button variant='contained'  color="primary"  style={{width:"7.8rem", backgroundColor:process.env.REACT_APP_Btn_Color}}
                        onClick={()=>setModalGPS(true)}>Editar GPS</Button>
                </Box>
            :null}
            {/* <FormControl component="fieldset" style={{marginLeft:.5+'rem', marginTop:".5rem" }}>          
        
                <RadioGroup  row aria-label="position"  defaultValue="top"
                    name="periodo" value={periodo} onChange={onChangeRad}
                >                        
                    <FormControlLabel value={"1A"}  label={"Primer Periodo"}
                        style={{}}
                        control={<Radio color="primary" />} />
                    <FormControlLabel value={"2A"}  label={"Segundo Periodo"}
                        style={{}}
                        control={<Radio color="primary" />} />                                                                      
                </RadioGroup>                     
            </FormControl>   */}
        </Box>        
        <Box  ml={1}>
            {!espera && listPoliDto.length!==0 && listMarcador.length!==0 && listPoliOtb.length!==0 
             //   && listColOtb.length !== 0 && listRutaGps.length !== 0 
             ? 
                <Mapa lista={listPoliDto} setLista={setLista} setActualiza={()=>setBandera(!bandera)} 
                    contador={contador} setContador={setContador} listMarcador={listMarcador} 
                    listPoliOtb={listPoliOtb} listColOtb={listColOtb} listNumOtb={listNumOtb}
                    listColPolig={listColPolig} listEleccion={listEleccion}
                  listRutaGps={listRutaGps}
                />
            : espera ?<Box mt={5}><LinearProgress/></Box>:null}
        </Box>
        <Box>
          {/*   <Button onClick={limpiar}>Limpiar</Button>
            <Button onClick={funcionUltimo} style={{marginLeft:"1rem", }}>Borrar ultimo</Button>
            <Tabla lista={lista} bandera={bandera} /> */}
        </Box>
    </Box>)
}

export default MapaRuta